'use client';

export default function Button({
  title,
  onClick,
  type = 'primary',
}: {
  title: string;
  onClick?: () => void;
  type?: 'primary' | 'secondary';
}) {
  return (
    <button
      className={`button ${
        type === 'primary' ? 'primary' : 'bg-gray-100 dark:bg-gray-700'
      }`}
      onClick={() => onClick?.()}
    >
      {title}
    </button>
  );
}
